import React, { useEffect, useState, useRef, forwardRef, useImperativeHandle } from 'react';
import { View, Text, Pressable, StyleSheet, Icon, Icon2, Icon3 } from '../lib/react-native-compat';
import { useAtom } from 'jotai';
import { loadJobCostHistoryLive, loadARServiceBillingConsolidated, loadBillablePhases, fNum, pNum } from '../db/company';
import { selectedTeamAtom, dataSourceJobsAtom } from '../store/company';
import moment from 'moment';

import xlsx from 'xlsx';
import XLSX from 'xlsx';

// Rolling 9 = the last 9 completed ISO weeks (Mon-Sun), ending with the most
// recently completed week. Keyed by week-start date string so the per-week
// buckets line up with the legacy per-version buckets the old report used.
const computeRollingNineWeeks = (now = moment()) => {
    const lastWeekEnd = now.clone().startOf('isoWeek').subtract(1, 'day'); // Sunday
    const weeks = [];
    for (let i = 8; i >= 0; i--) {
        const end = lastWeekEnd.clone().subtract(i * 7, 'day');
        const start = end.clone().subtract(6, 'day');
        weeks.push({
            key: start.format('YYYY-MM-DD'),
            label: start.format('M/D'),
            start,
            end,
            dateLabel: start.format('M/D/YYYY')
        });
    }
    return weeks;
};

const weekKeyFor = (date, weeks) => {
    if (!date) return null;
    const d = moment(date);
    for (const w of weeks) {
        if (!d.isBefore(w.start, 'day') && !d.isAfter(w.end, 'day')) return w.key;
    }
    return null;
};

const TimeMaterialsReportRolling9 = forwardRef(({ photo, view, setJobRef, job, refSubNav }, ref) => {
    const [weekObjects] = useState(() => computeRollingNineWeeks())
    const rollingNineVersions = weekObjects.map(w => w.key)
    const weekByKey = Object.fromEntries(weekObjects.map(w => [w.key, w]))
    const [selectedTeam, setSelectedTeam] = useAtom(selectedTeamAtom);
    const [jobs, setJobs] = useAtom(dataSourceJobsAtom);
    const [billingRows, setBillingRows] = useState([])

    const [expandRev, setExpandRev] = useState(false)
    const [expandBilling, setExpandBilling] = useState(false)
    const [expandLab, setExpandLab] = useState(false)
    const [expandEquip, setExpandEquip] = useState(false)
    const [expandMat, setExpandMat] = useState(false)
    const [expandSub, setExpandSub] = useState(false)
    const [expandSubDetail, setExpandSubDetail] = useState(false)
    const [expandOther, setExpandOther] = useState(false)
    const [jobList, setJobList] = useState([])
    const [fetchedAllJobUserData, setFetchedAllJobUserData] = useState(false)
    const [actualCosts, setActualCosts] = useState({})
    const [ticketsNotInvoiced, setTicketsNotInvoiced] = useState({})
    const [uninvoicedTickets, setUninvoicedTickets] = useState({})
    const [uninvoicedTicketsData, setUninvoicedTicketsData] = useState([])
    const [inbetweenInvoiced, setInbetweenInvoiced] = useState({})
    const [teamBillings, setTeamBillings] = useState([]);
    const [invoicedAmounts, setInvoicedAmounts] = useState({});
    const [currentEarnedAmounts, setCurrentEarnedAmounts] = useState({});
    const [billablePhases, setBillablePhases] = useState([])
    const [nonBillable, setNonBillable] = useState({})
    const [openCommitments, setOpenCommitments] = useState({})
    const [openCommitmentsJob, setOpenCommitmentsJob] = useState({})
    const [billings, setBillings] = useState({})
    const [jobTotals, setJobTotals] = useState({})
    

    // Add new state variables for non-billable sections
    const [expandNonBillable, setExpandNonBillable] = useState(false)
    const [expandNonBillableLab, setExpandNonBillableLab] = useState(false)
    const [expandNonBillableEquip, setExpandNonBillableEquip] = useState(false)
    const [expandNonBillableSub, setExpandNonBillableSub] = useState(false)
    const [expandNonBillableMat, setExpandNonBillableMat] = useState(false)
    const [expandNonBillableSubDetail, setExpandNonBillableSubDetail] = useState(false)
    const [expandNonBillableOther, setExpandNonBillableOther] = useState(false)
    const [expandTicketNotInvoiced, setExpandTicketNotInvoiced] = useState(false)
    const [costRows, setCostRows] = useState([])
    const [versionData, setVersionData] = useState([]);
    const [expandVersions, setExpandVersions] = useState(false);
    const fileInput = useRef(null);
    const [file, setFile] = useState(null);
    const [waiting, setWaiting] = useState(false)
    const tildr = useRef([])

    const fileSelectedHandler = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);
        uploadPowerBI(selectedFile);
    }

    const uploadPowerBI = (file = null) => {
        console.log('upload excel', file)

        if (file) {

            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const parsedData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                const desiredColumns = [
                    'Client AFE #', 'Client PO #', 'Client WO #', 'Client Other #', 'Client Name',
                    'Job Number', 'Phase Type', 'Phase Code', 'Field Ticket Type', 'Ticket No',
                    'Ticket Date', 'Field Ticket State', 'Field Ticket Owner', 'Invoice Number',
                    'Invoice Date', 'Invoice Posting Date', 'Employee ID', 'Employee Name',
                    'Has Per Diem?', 'Is Truck Rent?', 'Is Weld Rig?', 'Labor Classification',
                    'Labor Combo Rate', 'ST Hours', 'OT Hours', 'Total Labor Hours', 'ST Rate',
                    'OT Rate', 'Daily Wage', 'Per Diem Amount', 'Labor Total', 'Equipment Description',
                    'Equipment Combo Rate', 'Unit Number', 'PO Number', 'Ticketed Hours', 'Rate',
                    'Surcharge', 'Sum of Amount', 'Material Name', 'Vendor Name', 'Vendor Invoice',
                    'Is Estimate?', 'Cost', 'Markup', 'Sales Tax', 'Material Amount', 'Description',
                    'Tax Category Name'
                ];
                const columnIndexMap = {};
                const parsedColumns = parsedData[0];
                desiredColumns.forEach((col) => {
                    const index = parsedColumns.indexOf(col);
                    if (index !== -1) {
                        columnIndexMap[col] = index;
                    }
                });

                const extractedData = parsedData.slice(1).map((row) => {
                    const rowData = {};
                    desiredColumns.forEach((col) => {
                        rowData[col] = row[columnIndexMap[col]];
                    });
                    return rowData;
                });
                console.log('extractedData', extractedData)
                //setTildr(extractedData)
            }
            reader.readAsArrayBuffer(file)
        }
    }

    const exportToExcel = async () => {
        const headers = [
            'Job Number', 'Week Start', 'Active / Closed', 'Client', 'Job Name',
            'Invoiced to Date', 'Current Earned',
            'Total Billable Cost', 'Labor', 'Equipment', 'Third Party',
            'Billable Job Profit', 'Billable Job Margin',
            'Total Non-Billable Costs', 'OH %', 'Total Job Profit', 'Total Job Profit %'
        ];
        const rows = jobList.flatMap(job =>
            rollingNineVersions.map(v => {
                const jobActualCosts = actualCosts[v]?.[job.BU_ID] || {};
                const totalBillable = (jobActualCosts.labor || 0) + (jobActualCosts.equipment || 0) + (jobActualCosts.thirdParty || 0);
                const nonBillableAmount = nonBillable?.[v]?.[job.BU_ID]?.total || 0;
                const currentEarned = currentEarnedAmounts?.[v]?.[job.BU_ID] || 0;
                const billableJobProfit = currentEarned - totalBillable;
                const billableJobMargin = currentEarned ? (billableJobProfit / currentEarned * 100) : 0;
                const netProfit = billableJobProfit - nonBillableAmount;
                const netProfitPercent = currentEarned ? (netProfit / currentEarned * 100) : 0;
                const ohPercent = (nonBillableAmount + totalBillable) ? (nonBillableAmount / (nonBillableAmount + totalBillable)) * 100 : 0;
                return [
                    job.BU_ID, weekByKey[v]?.dateLabel || v, job.Job_Status, job.AR_AB_Name, job.BU_Description,
                    invoicedAmounts[v]?.[job.BU_ID] || 0,
                    currentEarned || 0,
                    totalBillable || 0,
                    jobActualCosts.labor || 0, jobActualCosts.equipment || 0, jobActualCosts.thirdParty || 0,
                    billableJobProfit || 0, billableJobMargin ? billableJobMargin.toFixed(1) + '%' : '',
                    nonBillableAmount || 0, ohPercent ? ohPercent.toFixed(1) + '%' : '',
                    netProfit || 0, netProfitPercent ? netProfitPercent.toFixed(1) + '%' : ''
                ];
            })
        );
        const wb = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(wb, xlsx.utils.aoa_to_sheet([headers, ...rows]), 'Rolling 9');
        const out = xlsx.write(wb, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([out], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `TandMRolling9-${moment().format('YYYY.MM.DD')}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
    };

    // Expose exportToExcel so the parent's toolbar Download button can trigger
    // it without us having to render our own download button inside the view.
    useImperativeHandle(ref, () => ({ exportToExcel }), [exportToExcel]);


    useEffect(() => {
        if (!fetchedAllJobUserData && jobList?.length > 0 && selectedTeam) {
            setFetchedAllJobUserData(true)
            const jobIds = jobList.map(job => job.BU_ID)
            const billable = {}

            // Pull all cost history within the 9-week window in a single call
            // (the SQL is pre-aggregated to date/phase/cost-type granularity).
            const windowStart = rollingNineVersions[0]; // earliest week key = YYYY-MM-DD

            setWaiting(true)
            loadBillablePhases({ ids: jobIds }).then((data) => {
                console.log('billable phases data:', data);
                data?.data?.forEach((d, index) => {
                    // Build billable lookup using Job_Number and Phase_Code
                    if (billable[d?.Job_Number] && billable[d?.Job_Number][d?.Phase_Code]) {
                        // Already exists
                    } else if (billable[d?.Job_Number]) {
                        billable[d?.Job_Number][d?.Phase_Code] = true
                    } else {
                        billable[d?.Job_Number] = {
                            [d?.Phase_Code]: true
                        }
                    }
                })
                setBillablePhases(billable)
            })

            // Cost history + AR Service Billing, both per-job, both date-windowed
            // to the 9-week roll. Single call each — the SQL aggregates already.
            Promise.all([
                loadJobCostHistoryLive({ ids: jobIds, startDate: windowStart }),
                loadARServiceBillingConsolidated({ ids: jobIds })
            ]).then(([costRes, billRes]) => {
                if (costRes?.error) console.warn('[Rolling 9] readJobCostHistoryLive error:', costRes);
                if (billRes?.error) console.warn('[Rolling 9] readARServiceBillingConsolidated error:', billRes);
                setCostRows(costRes?.data || [])
                setBillingRows(billRes?.data || [])
                setWaiting(false)
            }).catch(err => {
                console.error('[Rolling 9] data fetch failed', err);
                setWaiting(false);
            })
        }
    }, [jobList, selectedTeam])

    // Bucket AR Service Billing rows into per-week revenue totals.
    // - currentEarnedAmounts[weekKey][jobId] = sum of Amount (any line)
    // - invoicedAmounts[weekKey][jobId]      = sum of Amount where Invoice_Number is set
    useEffect(() => {
        if (!billingRows?.length) {
            setCurrentEarnedAmounts({});
            setInvoicedAmounts({});
            return;
        }
        const earned = {};
        const invoiced = {};
        rollingNineVersions.forEach(k => { earned[k] = {}; invoiced[k] = {}; });
        billingRows.forEach(row => {
            const d = row?.GL_Date || row?.Invoice_Date || row?.Service_Date;
            const wk = weekKeyFor(d, weekObjects);
            if (!wk) return;
            const jobId = row?.BU_ID;
            if (!jobId) return;
            const amt = pNum(row.Amount) || pNum(row.Invoice_Amount) || pNum(row.Revenue_Amount) || pNum(row.Extended_Price_Amount);
            earned[wk][jobId] = (earned[wk][jobId] || 0) + amt;
            if (row.Invoice_Number) {
                invoiced[wk][jobId] = (invoiced[wk][jobId] || 0) + amt;
            }
        });
        setCurrentEarnedAmounts(earned);
        setInvoicedAmounts(invoiced);
    }, [billingRows])

    // Bucket cost-history rows into per-week × per-job × per-category totals,
    // split into billable vs non-billable using the billablePhases lookup.
    useEffect(() => {
        const nonBillableCostsVersion = {}
        const billableCostsVersion = {}
        rollingNineVersions.forEach(k => { nonBillableCostsVersion[k] = {}; billableCostsVersion[k] = {}; });
        costRows?.forEach(d => {
            const wk = weekKeyFor(d?.GL_Date, weekObjects);
            if (!wk) return;
            const jobId = d.Job_Number;
            if (!jobId) return;
            const isBillable = !!billablePhases?.[jobId]?.[d.Phase_Code];
            const cost = pNum(d.Job_Cost);
            const code = d.Cost_Type_Code;
            const bucket = isBillable ? billableCostsVersion[wk] : nonBillableCostsVersion[wk];
            if (!bucket[jobId]) {
                bucket[jobId] = { labor: 0, equipment: 0, thirdParty: 0, materials: 0, subs: 0, other: 0, total: 0 }
            }
            bucket[jobId][code] = (bucket[jobId][code] || 0) + cost;
            if (code == '51100' || code == '51200' || code == '51300' || code == '51350' || code == '51400' || code == '51500' || code == '51600' || code == '51700' || code == '51800') {
                bucket[jobId]['labor'] += cost;
            } else if (code == '52100' || code == '52200' || code == '52300' || code == '52400') {
                bucket[jobId]['equipment'] += cost;
            } else if (code == '53100' || code == '53200' || code == '53300' || code == '53400') {
                bucket[jobId]['materials'] += cost;
            } else if (code == '54100' || code == '54200' || code == '54300') {
                bucket[jobId]['subs'] += cost;
            } else if (code == '55100' || code == '55200' || code == '55300' || code == '55400' || code == '55900' || code == '56100' || code == '56500' || code == '57900') {
                bucket[jobId]['other'] += cost;
            }
            if (code == '53100' || code == '53200' || code == '53300' || code == '53400' || code == '54100' || code == '54200' || code == '54300' || code == '55100' || code == '55200' || code == '55300' || code == '55400' || code == '55900' || code == '56100' || code == '56500' || code == '57900') {
                bucket[jobId]['thirdParty'] += cost;
            }
            if (code && code[0] == '5') {
                bucket[jobId]['total'] += cost;
            }
        });
        setNonBillable(nonBillableCostsVersion)
        setActualCosts(billableCostsVersion)
    }, [costRows, billablePhases])

    useEffect(() => {
        if (selectedTeam) {
            console.log('selected team', selectedTeam)
            let filtered = []
            filtered = jobs ? jobs.filter(job => job.Cat_Code_BU_27 == selectedTeam).filter(a => a.Cat_Code_BU_08 == 'T&M') : []
            console.log('jobs', filtered)
            filtered.sort((a, b) => a.BU_ID.localeCompare(b.BU_ID));
        console.log('filtered job list', filtered)
            setFetchedAllJobUserData(false)
            setJobList(filtered)
        }
    }, [jobs, selectedTeam])


    const s = StyleSheet.create({
        cell: {
            borderBottom: '1px solid #e2e8f0',
            padding: '3px 6px',
            fontSize: 10,
            textAlign: 'right',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            color: '#0f172a',
            fontVariantNumeric: 'tabular-nums'
        },
        cellt: {
            borderBottom: '1px solid #cbd5e1',
            padding: '4px 6px',
            textAlign: 'right',
            fontSize: 10,
            fontWeight: 600,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            color: '#334155',
            fontVariantNumeric: 'tabular-nums'
        },
        celll: {
            borderBottom: '1px solid #e2e8f0',
            padding: '3px 6px',
            textAlign: 'left',
            fontSize: 10,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            color: '#0f172a'
        }
    });

    const Row = ({ job, version, first }) => {
        const [expanded, setExpanded] = useState(false);
        const v = version;
        const versionDate = weekByKey[version]?.dateLabel || ''


        // Calculate total billable for this job
        const jobActualCosts = actualCosts[v]?.[job.BU_ID] || {};
        const totalBillable = (jobActualCosts.labor || 0) +
            (jobActualCosts.equipment || 0) +
            (jobActualCosts.thirdParty || 0);

        // Calculate OH %
        const nonBillableAmount = nonBillable?.[v]?.[job.BU_ID]?.total || 0;
        const ohPercent = (nonBillableAmount / (nonBillableAmount + totalBillable)) * 100;

        // Calculate billable job profit and margin
        const currentEarned = currentEarnedAmounts?.[v]?.[job.BU_ID] || 0;
        const billableJobProfit = currentEarned - totalBillable;
        const billableJobMargin = currentEarned ? (billableJobProfit / currentEarned * 100) : 0;

        // Calculate non-billable job profit and margin
        const netProfit = billableJobProfit - nonBillableAmount;
        const netProfitPercent = currentEarned ? (netProfit / currentEarned * 100) : 0;

        const openPoAmount = openCommitmentsJob[job.BU_ID]?.reduce((acc, po) => acc + (po.PO_True_Open_Amount ? pNum(po.PO_True_Open_Amount) : 0), 0) || 0

        const prevVersion = rollingNineVersions[rollingNineVersions.indexOf(v) - 1];
        const twoWeeksAgoVersion = rollingNineVersions[rollingNineVersions.indexOf(v) - 2];

        let prevBillableJobProfit = prevVersion ? (
            (currentEarnedAmounts?.[prevVersion]?.[job.BU_ID] || 0) -
            ((actualCosts?.[prevVersion]?.[job.BU_ID]?.labor || 0) +
                (actualCosts?.[prevVersion]?.[job.BU_ID]?.equipment || 0) +
                (actualCosts?.[prevVersion]?.[job.BU_ID]?.thirdParty || 0))
        ) : null;

        let prevBillableJobMargin = prevVersion && (currentEarnedAmounts?.[prevVersion]?.[job.BU_ID] || 0)
            ? ((prevBillableJobProfit / currentEarnedAmounts[prevVersion][job.BU_ID]) * 100)
            : null;

        let twoWeeksBillableJobProfit = twoWeeksAgoVersion ? (
            (currentEarnedAmounts?.[twoWeeksAgoVersion]?.[job.BU_ID] || 0) -
            ((actualCosts?.[twoWeeksAgoVersion]?.[job.BU_ID]?.labor || 0) +
                (actualCosts?.[twoWeeksAgoVersion]?.[job.BU_ID]?.equipment || 0) +
                (actualCosts?.[twoWeeksAgoVersion]?.[job.BU_ID]?.thirdParty || 0))
        ) : null;

        let twoWeeksBillableJobMargin = twoWeeksAgoVersion && (currentEarnedAmounts?.[twoWeeksAgoVersion]?.[job.BU_ID] || 0)
            ? ((twoWeeksBillableJobProfit / currentEarnedAmounts[twoWeeksAgoVersion][job.BU_ID]) * 100)
            : null;

        const wkToWkGainFadeDollar = prevBillableJobProfit !== null ? fNum(billableJobProfit - prevBillableJobProfit) : '';
        const wkToWkGainFadePercent = prevBillableJobMargin !== null ? (billableJobMargin - prevBillableJobMargin).toFixed(2) + '%' : '';
        const twoWkGainFadeDollar = twoWeeksBillableJobProfit !== null ? fNum(billableJobProfit - twoWeeksBillableJobProfit) : '';
        const twoWkGainFadePercent = twoWeeksBillableJobMargin !== null ? (billableJobMargin - twoWeeksBillableJobMargin).toFixed(2) + '%' : '';

        return (
            <View>
                {first || expandVersions == job ? <View style={{ flexDirection: 'row', marginLeft: 10, backgroundColor: first ? '#ffffff' : '#fafafa' }}>
                    {first ? <Pressable
                        style={[s.cell, { width: 30 }]}
                        onPress={() => setExpandVersions(expandVersions == job ? false : job)}>
                        <Icon name={expandVersions == job ? "chevron-down" : "chevron-right"} size={15} color="black" />
                    </Pressable> : <View style={{ width: 30, backgroundColor: 'white' }}></View>}
                    {/* {expandVersions && versionData.map((version, index) => {
                        const versionJobData = version.data.find(d => d.BU_ID === job.BU_ID) || {};
                        return (
                            <View key={index} style={{ flexDirection: 'row' }}>
                                <Text style={[s.cell, { width: 100 }]}>{`v${version.version}`}</Text>
                                <Text style={[s.cell, { width: 100 }]}>{versionJobData.Total_Job_Cost ? fNum(versionJobData.Total_Job_Cost, 1) : ''}</Text>
                            </View>
                        );
                    })} */}

                    {first ? <Text style={[s.cell, { width: 70 }]}>{job.BU_ID}</Text> : <View style={{ width: 70, backgroundColor: 'white' }}></View>}
                    <Text style={[s.cell, { width: 110 }]}>Wk of {versionDate}</Text>
                    <Text style={[s.cell, { width: 50 }]}>{job.Job_Status}</Text>
                    <Text style={[s.cell, { width: 200 }]}>{job.AR_AB_Name}</Text>
                    <Text style={[s.cell, { width: 200 }]}>{job.BU_Description}</Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cell, { width: 100 }]}>{currentEarned ? fNum(currentEarned, 1) : ''}</Text>

                    {expandRev ? (
                        <View style={{ flexDirection: 'row' }}>
                            <Text style={[s.cell, { width: 100, backgroundColor: '#f8fafc' }]}>{invoicedAmounts[v]?.[job.BU_ID] ? fNum(invoicedAmounts[v]?.[job.BU_ID], 1) : ''}</Text>
                            <Text style={[s.cell, { width: 100, backgroundColor: '#f8fafc' }]}>{ticketsNotInvoiced[v]?.[job.BU_ID] ? fNum(ticketsNotInvoiced[v]?.[job.BU_ID], 1) : ''}</Text>
                            {expandTicketNotInvoiced && (
                                <View style={{ flexDirection: 'row' }}>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{uninvoicedTickets[v]?.[job.BU_ID] ? fNum(uninvoicedTickets[v]?.[job.BU_ID], 1) : ''}</Text>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{inbetweenInvoiced[v]?.[job.BU_ID] ? fNum(inbetweenInvoiced[v]?.[job.BU_ID], 1) : ''}</Text>
                                </View>
                            )}

                        </View>
                    ) : null}
                    <View style={{ width: 5 }}></View>
                    {expandBilling ? (
                        <View style={{ flexDirection: 'row' }}>
                            <Text style={[s.cell, { width: 100 }]}>{totalBillable ? fNum(totalBillable, 1) : ''}</Text>
                            <Text style={[s.cell, { width: 100, backgroundColor: '#f8fafc' }]}>{actualCosts[v]?.[job.BU_ID]?.labor ? fNum(actualCosts[v]?.[job.BU_ID]?.labor, 1) : ''}</Text>
                            {expandLab && (
                                <View style={{ flexDirection: 'row' }}>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{actualCosts[v]?.[job.BU_ID]?.['51100'] ? fNum(actualCosts[v]?.[job.BU_ID]?.['51100'], 1) : ''}</Text>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{actualCosts[v]?.[job.BU_ID]?.['51200'] ? fNum(actualCosts[v]?.[job.BU_ID]?.['51200'], 1) : ''}</Text>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{actualCosts[v]?.[job.BU_ID]?.['51300'] || actualCosts[v]?.[job.BU_ID]?.['51350'] ? fNum(pNum(actualCosts[v]?.[job.BU_ID]?.['51300']) + pNum(actualCosts[v]?.[job.BU_ID]?.['51350']), 1) : ''}</Text>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{actualCosts[v]?.[job.BU_ID]?.['51400'] ? fNum(actualCosts[v]?.[job.BU_ID]?.['51400'], 1) : ''}</Text>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{actualCosts[v]?.[job.BU_ID]?.['51500'] ? fNum(actualCosts[v]?.[job.BU_ID]?.['51500'], 1) : ''}</Text>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{actualCosts[v]?.[job.BU_ID]?.['51600'] ? fNum(actualCosts[v]?.[job.BU_ID]?.['51600'], 1) : ''}</Text>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{actualCosts[v]?.[job.BU_ID]?.['51700'] ? fNum(actualCosts[v]?.[job.BU_ID]?.['51700'], 1) : ''}</Text>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{actualCosts[v]?.[job.BU_ID]?.['51800'] ? fNum(actualCosts[v]?.[job.BU_ID]?.['51800'], 1) : ''}</Text>
                                </View>
                            )}
                            <Text style={[s.cell, { width: 100, backgroundColor: '#f8fafc' }]}>{actualCosts[v]?.[job.BU_ID]?.equipment ? fNum(actualCosts[v]?.[job.BU_ID]?.equipment, 1) : ''}</Text>
                            {expandEquip && (
                                <View style={{ flexDirection: 'row' }}>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['52100'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['52100'], 1) : ''}</Text>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['52200'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['52200'], 1) : ''}</Text>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['52300'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['52300'], 1) : ''}</Text>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['52400'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['52400'], 1) : ''}</Text>
                                </View>
                            )}
                            <Text style={[s.cell, { width: 100, backgroundColor: '#f8fafc' }]}>{actualCosts?.[v]?.[job.BU_ID]?.thirdParty ? fNum(actualCosts?.[v]?.[job.BU_ID]?.thirdParty, 1) : ''}</Text>

                            {expandSub && (
                                <View style={{ flexDirection: 'row' }}>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#e2e8f0' }]}>{actualCosts?.[v]?.[job.BU_ID]?.materials ? fNum(actualCosts?.[v]?.[job.BU_ID]?.materials, 1) : ''}</Text>
                                    {expandMat && (
                                        <View style={{ flexDirection: 'row' }}>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['53100'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['53100'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['53200'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['53200'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['53300'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['53300'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['53400'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['53400'], 1) : ''}</Text>
                                        </View>
                                    )}
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#e2e8f0' }]}>{actualCosts?.[v]?.[job.BU_ID]?.subs ? fNum(actualCosts?.[v]?.[job.BU_ID]?.subs, 1) : ''}</Text>
                                    {expandSubDetail && (
                                        <View style={{ flexDirection: 'row' }}>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['54100'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['54100'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['54200'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['54200'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['54300'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['54300'], 1) : ''}</Text>
                                        </View>
                                    )}
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#e2e8f0' }]}>{actualCosts?.[v]?.[job.BU_ID]?.other ? fNum(actualCosts?.[v]?.[job.BU_ID]?.other, 1) : ''}</Text>
                                    {expandOther && (
                                        <View style={{ flexDirection: 'row' }}>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['55100'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['55100'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['55200'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['55200'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['55300'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['55300'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['55400'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['55400'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['55900'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['55900'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['56100'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['56100'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['56500'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['56500'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{actualCosts?.[v]?.[job.BU_ID]?.['57900'] ? fNum(actualCosts?.[v]?.[job.BU_ID]?.['57900'], 1) : ''}</Text>
                                        </View>
                                    )}
                                </View>
                            )}
                        </View>
                    ) : (
                        <Text style={[s.cell, { width: 100 }]}>{totalBillable ? fNum(totalBillable, 1) : ''}</Text>
                    )}
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cell, { width: 100, fontWeight: 600 }]}>{billableJobProfit ? fNum(billableJobProfit, 1) : ''}</Text>
                    <Text style={[s.cell, { width: 100, backgroundColor: billableJobMargin > 40 ? '#bbf7d0' : billableJobMargin < 10 ? '#fecaca' : '', fontWeight: 600 }]}>{billableJobMargin ? parseFloat(billableJobMargin).toFixed(1) + '%' : ''}</Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cell, { width: 100 }]}>{nonBillable?.[v]?.[job.BU_ID]?.total ? fNum(nonBillable?.[v]?.[job.BU_ID]?.total, 1) : ''}</Text>
                    {expandNonBillable ? (
                        <View style={{ flexDirection: 'row' }}>
                            <Text style={[s.cell, { width: 100, backgroundColor: '#f8fafc' }]}>{nonBillable?.[v]?.[job.BU_ID]?.labor ? fNum(nonBillable?.[v]?.[job.BU_ID]?.labor, 1) : ''}</Text>
                            {expandNonBillableLab && (<View style={{ flexDirection: 'row' }}>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['51100'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['51100'], 1) : ''}</Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['51200'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['51200'], 1) : ''}</Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['51300'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['51300'], 1) : ''}</Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['51400'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['51400'], 1) : ''}</Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['51500'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['51500'], 1) : ''}</Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['51600'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['51600'], 1) : ''}</Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['51700'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['51700'], 1) : ''}</Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['51800'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['51800'], 1) : ''}</Text>
                            </View>)}
                            <Text style={[s.cell, { width: 100, backgroundColor: '#f8fafc' }]}>{nonBillable?.[v]?.[job.BU_ID]?.equipment ? fNum(nonBillable?.[v]?.[job.BU_ID]?.equipment, 1) : ''}</Text>
                            {expandNonBillableEquip && (
                                <View style={{ flexDirection: 'row' }}>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['52100'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['52100'], 1) : ''}</Text>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['52200'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['52200'], 1) : ''}</Text>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['52300'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['52300'], 1) : ''}</Text>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['52400'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['52400'], 1) : ''}</Text>

                                </View>
                            )}
                            <Text style={[s.cell, { width: 100, backgroundColor: '#f8fafc' }]}>{nonBillable?.[v]?.[job.BU_ID]?.thirdParty ? fNum(nonBillable?.[v]?.[job.BU_ID]?.thirdParty, 1) : ''}</Text>
                            {expandNonBillableSub && (
                                <View style={{ flexDirection: 'row' }}>
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#e2e8f0' }]}>{nonBillable?.[v]?.[job.BU_ID]?.materials ? fNum(nonBillable?.[v]?.[job.BU_ID]?.materials, 1) : ''}</Text>
                                    {expandNonBillableMat && (
                                        <View style={{ flexDirection: 'row' }}>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['53100'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['53100'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['53200'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['53200'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['53300'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['53300'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['53400'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['53400'], 1) : ''}</Text>
                                        </View>
                                    )}
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#e2e8f0' }]}>{nonBillable?.[v]?.[job.BU_ID]?.subs ? fNum(nonBillable?.[v]?.[job.BU_ID]?.subs, 1) : ''}</Text>
                                    {expandNonBillableSubDetail && (
                                        <View style={{ flexDirection: 'row' }}>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['54100'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['54100'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['54200'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['54200'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['54300'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['54300'], 1) : ''}</Text>

                                        </View>
                                    )}
                                    <Text style={[s.cell, { width: 100, backgroundColor: '#e2e8f0' }]}>{nonBillable?.[v]?.[job.BU_ID]?.other ? fNum(nonBillable?.[v]?.[job.BU_ID]?.other, 1) : ''}</Text>
                                    {expandNonBillableOther && (
                                        <View style={{ flexDirection: 'row' }}>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['55100'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['55100'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['55200'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['55200'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['55300'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['55300'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['55400'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['55400'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['55900'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['55900'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['56100'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['56100'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['56500'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['56500'], 1) : ''}</Text>
                                            <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{nonBillable?.[v]?.[job.BU_ID]?.['57900'] ? fNum(nonBillable?.[v]?.[job.BU_ID]?.['57900'], 1) : ''}</Text>

                                        </View>
                                    )}
                                </View>
                            )}
                        </View>
                    ) : null}
                    <Text style={[s.cell, { width: 100 }]}>{ohPercent ? fNum(ohPercent, 2) + '%' : ''}</Text>
                    {/* <View style={{ width: 5 }}></View>
                    <Text style={[s.cell, { width: 100 }]}>{job.nonBillableJobProfit ? fNum(job.nonBillableJobProfit, 1) : ''}</Text>
                    <Text style={[s.cell, { width: 100 }]}>{job.nonBillableJobMargin ? fNum(job.nonBillableJobMargin, 1) : ''}</Text> */}
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cell, { width: 100, fontWeight: 600 }]}>{netProfit ? fNum(netProfit, 1) : ''}</Text>
                    <Text style={[s.cell, { width: 100, backgroundColor: netProfitPercent > 40 ? '#bbf7d0' : netProfitPercent < 10 ? '#fecaca' : '', fontWeight: 600 }]}>{netProfitPercent ? parseFloat(netProfitPercent).toFixed(1) + '%' : ''}</Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cell, { width: 100 }]}>{wkToWkGainFadePercent}</Text>
                    <Text style={[s.cell, { width: 100 }]}>{wkToWkGainFadeDollar}</Text>
                    <Text style={[s.cell, { width: 100 }]}>{twoWkGainFadePercent}</Text>
                    <Text style={[s.cell, { width: 100 }]}>{twoWkGainFadeDollar}</Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cell, { width: 100 }]}>{openPoAmount ? fNum(openPoAmount, 1) : ''}</Text>
                </View> : null}
                {first && expandVersions == job ?
                    <View style={{ marginVertical: 20 }}>
                        <View style={{ flexDirection: 'row', paddingLeft: 10 }}>
                            <Text style={[{ width: 640 }]}></Text>
                            <View style={{ width: 5 }}></View>
                            <Text style={[s.cellt, { width: expandRev ? expandTicketNotInvoiced ? 500 : 300 : 100 }]}>Report Portal Est</Text>
                            <View style={{ width: 105 }}></View>
                            {expandBilling ? <View style={{ flexDirection: 'row' }}>
                                {/* Main columns: Labor, Equipment, Third Party */}
                                <Text style={[s.cell, { width: 100, backgroundColor: '#f8fafc' }]}>
                                    {jobTotals[job.BU_ID]?.labor ? fNum(jobTotals[job.BU_ID]?.labor, 1) : ''}
                                </Text>
                                {expandLab && <Text style={[{ width: 800 }]}></Text>}
                                <Text style={[s.cell, { width: 100, backgroundColor: '#f8fafc' }]}>
                                    {jobTotals[job.BU_ID]?.equipment ? fNum(jobTotals[job.BU_ID]?.equipment, 1) : ''}
                                </Text>
                                {expandEquip && <Text style={[{ width: 400 }]}></Text>}
                                <Text style={[s.cell, { width: 100, backgroundColor: '#f8fafc' }]}>
                                    {jobTotals[job.BU_ID]?.material ? fNum(jobTotals[job.BU_ID]?.material, 1) : ''}
                                </Text>
                            </View> : null}
                        </View>
                        <View style={{ flexDirection: 'row', paddingLeft: 10 }}>
                            <Text style={[{ width: 640 }]}></Text>
                            <View style={{ width: 5 }}></View>
                            <Text style={[s.cellt, { width: expandRev ? expandTicketNotInvoiced ? 500 : 300 : 100 }]}>Billable Job Profit Est</Text>
                            <View style={{ width: 105 }}></View>
                            {expandBilling ? <View style={{ flexDirection: 'row' }}>
                                {/* Main columns: Labor, Equipment, Third Party */}
                                <Text style={[s.cell, { width: 100, backgroundColor: '#f8fafc' }]}>
                                    {actualCosts[v]?.[job.BU_ID]?.equipment && jobTotals[job.BU_ID]?.labor ? fNum(jobTotals[job.BU_ID]?.labor - actualCosts[v]?.[job.BU_ID]?.labor, 1) : ''}
                                </Text>
                                {expandLab && <Text style={[{ width: 800 }]}></Text>}
                                <Text style={[s.cell, { width: 100, backgroundColor: '#f8fafc' }]}>
                                    {actualCosts[v]?.[job.BU_ID]?.equipment && jobTotals[job.BU_ID]?.equipment ? fNum(jobTotals[job.BU_ID]?.equipment - actualCosts[v]?.[job.BU_ID]?.equipment, 1) : ''}
                                </Text>
                                {expandEquip && <Text style={[{ width: 400 }]}></Text>}
                                <Text style={[s.cell, { width: 100, backgroundColor: '#f8fafc' }]}>
                                    {actualCosts[v]?.[job.BU_ID]?.thirdParty && jobTotals[job.BU_ID]?.material ? fNum(jobTotals[job.BU_ID]?.material - actualCosts[v]?.[job.BU_ID]?.thirdParty, 1) : ''}
                                </Text>
                            </View> : null}
                        </View>
                        <View style={{ flexDirection: 'row', paddingLeft: 10 }}>
                            <Text style={[{ width: 640 }]}></Text>
                            <View style={{ width: 5 }}></View>
                            <Text style={[s.cellt, { width: expandRev ? expandTicketNotInvoiced ? 500 : 300 : 100 }]}>Profit Margin Est</Text>
                            <View style={{ width: 105 }}></View>
                            {expandBilling ? <View style={{ flexDirection: 'row' }}>
                                {/* Main columns: Labor, Equipment, Third Party */}
                                <Text style={[s.cell, { width: 100, backgroundColor: '#f8fafc' }]}>
                                    {actualCosts[v]?.[job.BU_ID]?.equipment && jobTotals[job.BU_ID]?.labor ? fNum((jobTotals[job.BU_ID]?.labor - actualCosts[v]?.[job.BU_ID]?.labor) / jobTotals[job.BU_ID]?.labor * 100) + '%' : ''}
                                </Text>
                                {expandLab && <Text style={[{ width: 800 }]}></Text>}
                                <Text style={[s.cell, { width: 100, backgroundColor: '#f8fafc' }]}>
                                    {actualCosts[v]?.[job.BU_ID]?.equipment && jobTotals[job.BU_ID]?.equipment ? fNum((jobTotals[job.BU_ID]?.equipment - actualCosts[v]?.[job.BU_ID]?.equipment) / jobTotals[job.BU_ID]?.equipment * 100) + '%' : ''}
                                </Text>
                                {expandEquip && <Text style={[{ width: 400 }]}></Text>}
                                <Text style={[s.cell, { width: 100, backgroundColor: '#f8fafc' }]}>
                                    {actualCosts[v]?.[job.BU_ID]?.thirdParty && jobTotals[job.BU_ID]?.material ? fNum((jobTotals[job.BU_ID]?.material - actualCosts[v]?.[job.BU_ID]?.thirdParty) / jobTotals[job.BU_ID]?.material * 100) + '%' : ''}
                                </Text>
                            </View> : null}
                        </View>
                    </View> : null}
            </View>
        );
    }

    const Header = () => {
        // Calculate widths for expandable sections
        const nonBillableWidth = expandNonBillable ? (
            (expandNonBillableLab ? 800 : 0) +
            (expandNonBillableEquip ? 400 : 0) +
            (expandNonBillableSub ? (
                (expandNonBillableMat ? 400 : 0) +
                (expandNonBillableSubDetail ? 300 : 0) +
                (expandNonBillableOther ? 800 : 0) +
                300
            ) : 0) +
            500
        ) : 200;

        const billableWidth = expandBilling ? (
            (expandLab ? 800 : 0) +
            (expandEquip ? 400 : 0) +
            (expandSub ? (
                (expandMat ? 400 : 0) +
                (expandSubDetail ? 300 : 0) +
                (expandOther ? 800 : 0) +
                300
            ) : 0) +
            400
        ) : 100;

        return (
            <View style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                <View style={{ flexDirection: 'row', paddingLeft: 10 }}>
                    <Text style={[s.cellt, { width: 660, backgroundColor: '#f1f5f9' }]}></Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cellt, { width: expandRev ? 500 : 100, backgroundColor: '#f1f5f9', textAlign: 'center' }]}>Total Revenue</Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cellt, { width: billableWidth, backgroundColor: '#f1f5f9', textAlign: 'center' }]}>Billable</Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cellt, { width: 200, backgroundColor: '#f1f5f9', fontWeight: 600, textAlign: 'center' }]}>Billable Job Profit</Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cellt, { width: nonBillableWidth, backgroundColor: '#f1f5f9', textAlign: 'center' }]}>Non-Billable</Text>

                    {/* <View style={{ width: 5 }}></View>
                    <Text style={[s.cellt, { width: 200, backgroundColor: '#f1f5f9' }]}>Non-Billable</Text> */}
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cellt, { width: 200, backgroundColor: '#f1f5f9', fontWeight: 600, textAlign: 'center' }]}>Total Job Profit</Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cellt, { width: 400, backgroundColor: '#f1f5f9', textAlign: 'center' }]}>Week to Week Change</Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9', textAlign: 'center' }]}>Other</Text>
                </View>
                <View style={{ flexDirection: 'row', paddingLeft: 10 }}>
                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Job Number</Text>
                    <Text style={[s.cellt, { width: 110, backgroundColor: '#f1f5f9' }]}>Week</Text>
                    <Text style={[s.cellt, { width: 50, backgroundColor: '#f1f5f9' }]}>Active / Closed</Text>
                    <Text style={[s.cellt, { width: 200, backgroundColor: '#f1f5f9' }]}>Client</Text>
                    <Text style={[s.cellt, { width: 200, backgroundColor: '#f1f5f9' }]}>Job Name</Text>
                    <View style={{ width: 5 }}></View>
                    <Pressable
                        style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}
                        onPress={() => setExpandRev(!expandRev)}>
                        <Icon name={expandRev ? "chevron-down" : "chevron-right"} size={15} color="black" />
                        <Text style={{ fontSize: 10 }}>Current Earned</Text>
                    </Pressable>
                    {expandRev ? <View style={{ flexDirection: 'row' }}>
                        <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Invoiced to Date</Text>
                        <Pressable
                            style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}
                            onPress={() => setExpandTicketNotInvoiced(!expandTicketNotInvoiced)}>
                            <Icon name={expandTicketNotInvoiced ? "chevron-down" : "chevron-right"} size={15} color="black" />
                            <Text style={{ fontSize: 10 }}>Tickets Not Yet Invoiced</Text>
                        </Pressable>
                        {expandTicketNotInvoiced ? <View style={{ flexDirection: 'row' }}>
                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Uninvoiced Tickets</Text>
                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Invoices Inbetween</Text>
                        </View> : null}
                    </View> : null}
                    <View style={{ width: 5 }}></View>
                    {expandBilling ? (
                        <View style={{ flexDirection: 'row' }}>
                            <Pressable
                                style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}
                                onPress={() => setExpandBilling(!expandBilling)}>
                                <Icon name={expandBilling ? "chevron-down" : "chevron-right"} size={15} color="black" />
                                <Text style={{ fontSize: 10 }}>Total Billable Cost</Text>
                            </Pressable>
                            <Pressable
                                style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}
                                onPress={() => setExpandLab(!expandLab)}>
                                <Icon name={expandLab ? "chevron-down" : "chevron-right"} size={15} color="black" />
                                <Text style={{ fontSize: 10 }}>Labor</Text>
                            </Pressable>
                            {expandLab && (
                                <View style={{ flexDirection: 'row' }}>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Regular Time (51100)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Overtime (51200)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Burden (51300)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>BYOD (51400)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Per Diem (51500)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Truck Pay (51600)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Welding Rig Pay (51700)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Field Bonus (51800)</Text>
                                </View>
                            )}
                            <Pressable
                                style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}
                                onPress={() => setExpandEquip(!expandEquip)}>
                                <Icon name={expandEquip ? "chevron-down" : "chevron-right"} size={15} color="black" />
                                <Text style={{ fontSize: 10 }}>Equipment</Text>
                            </Pressable>
                            {expandEquip && (
                                <View style={{ flexDirection: 'row' }}>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Inside Equip (52100)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Outside Equip (52200)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Fuel (52300)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Repairs (52400)</Text>
                                </View>
                            )}
                            <Pressable
                                style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}
                                onPress={() => setExpandSub(!expandSub)}>
                                <Icon name={expandSub ? "chevron-down" : "chevron-right"} size={15} color="black" />
                                <Text style={{ fontSize: 10 }}>Third Party</Text>
                            </Pressable>
                            {expandSub && (
                                <View style={{ flexDirection: 'row' }}>
                                    <Pressable
                                        style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}
                                        onPress={() => setExpandMat(!expandMat)}>
                                        <Icon name={expandMat ? "chevron-down" : "chevron-right"} size={15} color="black" />
                                        <Text style={{ fontSize: 10 }}>Materials</Text>
                                    </Pressable>
                                    {expandMat && (
                                        <View style={{ flexDirection: 'row' }}>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Materials (53100)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Mats (53200)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Tools & Supplies (53300)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Skids (53400)</Text>
                                        </View>
                                    )}
                                    <Pressable
                                        style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}
                                        onPress={() => setExpandSubDetail(!expandSubDetail)}>
                                        <Icon name={expandSubDetail ? "chevron-down" : "chevron-right"} size={15} color="black" />
                                        <Text style={{ fontSize: 10 }}>Subs</Text>
                                    </Pressable>
                                    {expandSubDetail && (
                                        <View style={{ flexDirection: 'row' }}>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Internal Subs (54100)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>External Subs (54200)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Hauling (54300)</Text>
                                        </View>
                                    )}
                                    <Pressable
                                        style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}
                                        onPress={() => setExpandOther(!expandOther)}>
                                        <Icon name={expandOther ? "chevron-down" : "chevron-right"} size={15} color="black" />
                                        <Text style={{ fontSize: 10 }}>Other</Text>
                                    </Pressable>
                                    {expandOther && (
                                        <View style={{ flexDirection: 'row' }}>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Personal Meals (55100)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Team Meals (55200)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Airfare (55300)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Lodging (55400)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Other Travel (55900)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Field Office (56100)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Safety & PPE (56500)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Misc (57900)</Text>
                                        </View>
                                    )}
                                </View>
                            )}
                        </View>
                    ) : (
                        <Pressable
                            style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}
                            onPress={() => setExpandBilling(!expandBilling)}>
                            <Icon name={expandBilling ? "chevron-down" : "chevron-right"} size={15} color="black" />
                            <Text style={{ fontSize: 10 }}>Total Billable Cost</Text>
                        </Pressable>
                    )}
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9', fontWeight: 600 }]}>Billable Job Profit</Text>
                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9', fontWeight: 600 }]}>Billable Job Profit %</Text>
                    <View style={{ width: 5 }}></View>
                    {expandNonBillable ? (
                        <View style={{ flexDirection: 'row' }}>
                            <Pressable
                                style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}
                                onPress={() => setExpandNonBillable(!expandNonBillable)}>
                                <Icon name={expandNonBillable ? "chevron-down" : "chevron-right"} size={15} color="black" />
                                <Text style={{ fontSize: 10 }}>Total Non Billable Cost</Text>
                            </Pressable>
                            <Pressable
                                style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}
                                onPress={() => setExpandNonBillableLab(!expandNonBillableLab)}>
                                <Icon name={expandNonBillableLab ? "chevron-down" : "chevron-right"} size={15} color="black" />
                                <Text style={{ fontSize: 10 }}>Labor</Text>
                            </Pressable>
                            {expandNonBillableLab && (
                                <View style={{ flexDirection: 'row' }}>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Regular Time (51100)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Overtime (51200)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Burden (51300)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>BYOD (51400)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Per Diem (51500)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Truck Pay (51600)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Welding Rig Pay (51700)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Field Bonus (51800)</Text>
                                </View>
                            )}
                            <Pressable
                                style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}
                                onPress={() => setExpandNonBillableEquip(!expandNonBillableEquip)}>
                                <Icon name={expandNonBillableEquip ? "chevron-down" : "chevron-right"} size={15} color="black" />
                                <Text style={{ fontSize: 10 }}>Equipment</Text>
                            </Pressable>
                            {expandNonBillableEquip && (
                                <View style={{ flexDirection: 'row' }}>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Inside Equip (52100)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Outside Equip (52200)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Fuel (52300)</Text>
                                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Repairs (52400)</Text>
                                </View>
                            )}
                            <Pressable
                                style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}
                                onPress={() => setExpandNonBillableSub(!expandNonBillableSub)}>
                                <Icon name={expandNonBillableSub ? "chevron-down" : "chevron-right"} size={15} color="black" />
                                <Text style={{ fontSize: 10 }}>Third Party</Text>
                            </Pressable>
                            {expandNonBillableSub && (
                                <View style={{ flexDirection: 'row' }}>
                                    <Pressable
                                        style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}
                                        onPress={() => setExpandNonBillableMat(!expandNonBillableMat)}>
                                        <Icon name={expandNonBillableMat ? "chevron-down" : "chevron-right"} size={15} color="black" />
                                        <Text style={{ fontSize: 10 }}>Materials</Text>
                                    </Pressable>
                                    {expandNonBillableMat && (
                                        <View style={{ flexDirection: 'row' }}>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Materials (53100)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Mats (53200)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Tools & Supplies (53300)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Skids (53400)</Text>
                                        </View>
                                    )}
                                    <Pressable
                                        style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}
                                        onPress={() => setExpandNonBillableSubDetail(!expandNonBillableSubDetail)}>
                                        <Icon name={expandNonBillableSubDetail ? "chevron-down" : "chevron-right"} size={15} color="black" />
                                        <Text style={{ fontSize: 10 }}>Subs</Text>
                                    </Pressable>
                                    {expandNonBillableSubDetail && (
                                        <View style={{ flexDirection: 'row' }}>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Internal Subs (54100)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>External Subs (54200)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Hauling (54300)</Text>
                                        </View>
                                    )}
                                    <Pressable
                                        style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}
                                        onPress={() => setExpandNonBillableOther(!expandNonBillableOther)}>
                                        <Icon name={expandNonBillableOther ? "chevron-down" : "chevron-right"} size={15} color="black" />
                                        <Text style={{ fontSize: 10 }}>Other</Text>
                                    </Pressable>
                                    {expandNonBillableOther && (
                                        <View style={{ flexDirection: 'row' }}>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Personal Meals (55100)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Team Meals (55200)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Airfare (55300)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Lodging (55400)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Other Travel (55900)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Field Office (56100)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Safety & PPE (56500)</Text>
                                            <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Misc (57900)</Text>
                                        </View>
                                    )}
                                </View>
                            )}
                        </View>
                    ) : (
                        <Pressable
                            style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}
                            onPress={() => setExpandNonBillable(!expandNonBillable)}>
                            <Icon name={expandNonBillable ? "chevron-down" : "chevron-right"} size={15} color="black" />
                            <Text style={{ fontSize: 10 }}>Total Non-Billable Costs</Text>
                        </Pressable>
                    )}
                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>OH %</Text>
                    {/* <View style={{ width: 5 }}></View>
                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Non Billable Job Profit</Text>
                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Non Billable Job Margin</Text> */}
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9', fontWeight: 600 }]}>Total Job Profit</Text>
                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9', fontWeight: 600 }]}>Total Job Profit %</Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Wk to Wk Gain/(Fade) %</Text>
                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Wk to Wk Gain/(Fade) $</Text>
                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>2 Weeks Ago Gain/(Fade) %</Text>
                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>2 Weeks Ago Gain/(Fade) $</Text>
                    <View style={{ width: 5 }}></View>
                    <Text style={[s.cellt, { width: 100, backgroundColor: '#f1f5f9' }]}>Open PO's</Text>

                </View>
            </View>
        )
    }


    const Footer = () => {
        // Only show footer for the most recent version (last in rollingNineVersions)
        const v = rollingNineVersions[rollingNineVersions.length - 1];
        // Totals for all jobs for the most recent version
        const totals = {
            currentEarned: 0,
            invoicedToDate: 0,
            ticketsNotYetInvoiced: 0,
            uninvoicedTickets: 0,
            inbetweenInvoiced: 0,
            totalBillableCost: 0,
            labor: 0,
            equipment: 0,
            thirdParty: 0,
            billableJobProfit: 0,
            billableJobMargin: 0,
            totalNonBillableCosts: 0,
            nonBillableLabor: 0,
            nonBillableEquipment: 0,
            nonBillableThirdParty: 0,
            nonBillableMaterials: 0,
            nonBillableSubs: 0,
            nonBillableOther: 0,
            netProfit: 0,
            netProfitPercent: 0,
            openPO: 0,
        };

        jobList.forEach(job => {
            const jobActualCosts = actualCosts[v]?.[job.BU_ID] || {};
            const totalBillable = (jobActualCosts.labor || 0) +
                (jobActualCosts.equipment || 0) +
                (jobActualCosts.thirdParty || 0);
            const nonBillableAmount = nonBillable?.[v]?.[job.BU_ID]?.total || 0;
            const currentEarned = currentEarnedAmounts?.[v]?.[job.BU_ID] || 0;
            const billableJobProfit = currentEarned - totalBillable;
            const billableJobMargin = currentEarned ? (billableJobProfit / currentEarned * 100) : 0;
            const netProfit = billableJobProfit - nonBillableAmount;
            const netProfitPercent = currentEarned ? (netProfit / currentEarned * 100) : 0;
            const openPoAmount = openCommitmentsJob[job.BU_ID]?.reduce((acc, po) => acc + (po.PO_True_Open_Amount ? pNum(po.PO_True_Open_Amount) : 0), 0) || 0;

            totals.currentEarned += currentEarned;
            totals.invoicedToDate += invoicedAmounts[v]?.[job.BU_ID] || 0;
            totals.ticketsNotYetInvoiced += ticketsNotInvoiced[v]?.[job.BU_ID] || 0;
            totals.uninvoicedTickets += uninvoicedTickets[v]?.[job.BU_ID] || 0;
            totals.inbetweenInvoiced += inbetweenInvoiced[v]?.[job.BU_ID] || 0;
            totals.totalBillableCost += totalBillable;
            totals.labor += jobActualCosts.labor || 0;
            totals.equipment += jobActualCosts.equipment || 0;
            totals.thirdParty += jobActualCosts.thirdParty || 0;
            totals.billableJobProfit += billableJobProfit;
            totals.billableJobMargin += billableJobMargin;
            totals.totalNonBillableCosts += nonBillableAmount;
            totals.billableLabor += actualCosts[v]?.[job.BU_ID]?.labor || 0;
            totals.billableEquipment += actualCosts[v]?.[job.BU_ID]?.equipment || 0;
            totals.billableThirdParty += actualCosts[v]?.[job.BU_ID]?.thirdParty || 0;
            totals.billableMaterials += actualCosts[v]?.[job.BU_ID]?.materials || 0;
            totals.billableSubs += actualCosts[v]?.[job.BU_ID]?.subs || 0;
            totals.billableOther += actualCosts[v]?.[job.BU_ID]?.other || 0;
            totals.nonBillableLabor += nonBillable?.[v]?.[job.BU_ID]?.labor || 0;
            totals.nonBillableEquipment += nonBillable?.[v]?.[job.BU_ID]?.equipment || 0;
            totals.nonBillableThirdParty += nonBillable?.[v]?.[job.BU_ID]?.thirdParty || 0;
            totals.nonBillableMaterials += nonBillable?.[v]?.[job.BU_ID]?.materials || 0;
            totals.nonBillableSubs += nonBillable?.[v]?.[job.BU_ID]?.subs || 0;
            totals.nonBillableOther += nonBillable?.[v]?.[job.BU_ID]?.other || 0;
            totals.netProfit += netProfit;
            totals.netProfitPercent += netProfitPercent;
            totals.openPO += openPoAmount;
        });

        // Averages for margin columns
        const jobCount = jobList.length || 1;
        const avgBillableJobMargin = totals.currentEarned ? (totals.billableJobProfit / totals.currentEarned * 100) : 0;
        const avgNetProfitPercent = totals.currentEarned ? (totals.netProfit / totals.currentEarned * 100) : 0;
        const ohPercent = (totals.totalNonBillableCosts / (totals.totalNonBillableCosts + totals.totalBillableCost)) * 100;

        return (
            <View style={{ flexDirection: 'row', paddingLeft: 10, backgroundColor: '#f5f5f5', borderTop: '1px solid #ccc' }}>
                <Text style={[s.cellt, { width: 30 }]}></Text>
                <Text style={[s.cellt, { width: 70 }]}>Totals</Text>
                <Text style={[s.cellt, { width: 110 }]}></Text>
                <Text style={[s.cellt, { width: 50 }]}></Text>
                <Text style={[s.cellt, { width: 200 }]}></Text>
                <Text style={[s.cellt, { width: 200 }]}></Text>
                <View style={{ width: 5 }}></View>
                <Text style={[s.cell, { width: 100 }]}>{totals.currentEarned ? fNum(totals.currentEarned, 1) : ''}</Text>
                {expandRev ? (
                    <View style={{ flexDirection: 'row' }}>
                        <Text style={[s.cell, { width: 100, backgroundColor: '#f8fafc' }]}>{totals.invoicedToDate ? fNum(totals.invoicedToDate, 1) : ''}</Text>
                        <Text style={[s.cell, { width: 100, backgroundColor: '#f8fafc' }]}>{totals.ticketsNotYetInvoiced ? fNum(totals.ticketsNotYetInvoiced, 1) : ''}</Text>
                        {expandTicketNotInvoiced && (
                            <View style={{ flexDirection: 'row' }}>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{totals.uninvoicedTickets ? fNum(totals.uninvoicedTickets, 1) : ''}</Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}>{totals.inbetweenInvoiced ? fNum(totals.inbetweenInvoiced, 1) : ''}</Text>
                            </View>
                        )}
                    </View>
                ) : null}
                <View style={{ width: 5 }}></View>
                {expandBilling ? (
                    <View style={{ flexDirection: 'row' }}>
                        <Text style={[s.cell, { width: 100 }]}>{totals.totalBillableCost ? fNum(totals.totalBillableCost, 1) : ''}</Text>
                        <Text style={[s.cell, { width: 100, backgroundColor: '#f8fafc' }]}>{totals.labor ? fNum(totals.labor, 1) : ''}</Text>
                        {expandLab && (
                            <View style={{ flexDirection: 'row' }}>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                            </View>
                        )}
                        <Text style={[s.cell, { width: 100, backgroundColor: '#f8fafc' }]}>{totals.equipment ? fNum(totals.equipment, 1) : ''}</Text>
                        {expandEquip && (
                            <View style={{ flexDirection: 'row' }}>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                            </View>
                        )}
                        <Text style={[s.cell, { width: 100, backgroundColor: '#f8fafc' }]}>{totals.thirdParty ? fNum(totals.thirdParty, 1) : ''}</Text>
                        {expandSub && (
                            <View style={{ flexDirection: 'row' }}>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#e2e8f0' }]}>{totals.billableMaterials ? fNum(totals.billableMaterials, 1) : ''}</Text>
                                {expandMat && (
                                    <View style={{ flexDirection: 'row' }}>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                    </View>
                                )}
                                <Text style={[s.cell, { width: 100, backgroundColor: '#e2e8f0' }]}>{totals.billableSubs ? fNum(totals.billableSubs, 1) : ''}</Text>
                                {expandSubDetail && (
                                    <View style={{ flexDirection: 'row' }}>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                    </View>
                                )}
                                <Text style={[s.cell, { width: 100, backgroundColor: '#e2e8f0' }]}>{totals.billableOther ? fNum(totals.billableOther, 1) : ''}</Text>
                                {expandOther && (
                                    <View style={{ flexDirection: 'row' }}>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                    </View>
                                )}
                            </View>
                        )}
                    </View>
                ) : (
                    <Text style={[s.cell, { width: 100 }]}>{totals.totalBillableCost ? fNum(totals.totalBillableCost, 1) : ''}</Text>
                )}
                <View style={{ width: 5 }}></View>
                <Text style={[s.cell, { width: 100, fontWeight: 600 }]}>{totals.billableJobProfit ? fNum(totals.billableJobProfit, 1) : ''}</Text>
                <Text style={[s.cell, { width: 100, backgroundColor: avgBillableJobMargin > 40 ? '#bbf7d0' : avgBillableJobMargin < 10 ? '#fecaca' : '', fontWeight: 600 }]}>{avgBillableJobMargin ? parseFloat(avgBillableJobMargin).toFixed(1) + '%' : ''}</Text>
                <View style={{ width: 5 }}></View>
                <Text style={[s.cell, { width: 100 }]}>{totals.totalNonBillableCosts ? fNum(totals.totalNonBillableCosts, 1) : ''}</Text>
                {expandNonBillable ? (
                    <View style={{ flexDirection: 'row' }}>
                        <Text style={[s.cell, { width: 100, backgroundColor: '#f8fafc' }]}>{totals.nonBillableLabor ? fNum(totals.nonBillableLabor, 1) : ''}</Text>
                        {expandNonBillableLab && (
                            <View style={{ flexDirection: 'row' }}>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                            </View>
                        )}
                        <Text style={[s.cell, { width: 100, backgroundColor: '#f8fafc' }]}>{totals.nonBillableEquipment ? fNum(totals.nonBillableEquipment, 1) : ''}</Text>
                        {expandNonBillableEquip && (
                            <View style={{ flexDirection: 'row' }}>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                            </View>
                        )}
                        <Text style={[s.cell, { width: 100, backgroundColor: '#f8fafc' }]}>{totals.nonBillableThirdParty ? fNum(totals.nonBillableThirdParty, 1) : ''}</Text>
                        {expandNonBillableSub && (
                            <View style={{ flexDirection: 'row' }}>
                                <Text style={[s.cell, { width: 100, backgroundColor: '#e2e8f0' }]}>{totals.nonBillableMaterials ? fNum(totals.nonBillableMaterials, 1) : ''}</Text>
                                {expandNonBillableMat && (
                                    <View style={{ flexDirection: 'row' }}>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                    </View>
                                )}
                                <Text style={[s.cell, { width: 100, backgroundColor: '#e2e8f0' }]}>{totals.nonBillableSubs ? fNum(totals.nonBillableSubs, 1) : ''}</Text>
                                {expandNonBillableSubDetail && (
                                    <View style={{ flexDirection: 'row' }}>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                    </View>
                                )}
                                <Text style={[s.cell, { width: 100, backgroundColor: '#e2e8f0' }]}>{totals.nonBillableOther ? fNum(totals.nonBillableOther, 1) : ''}</Text>
                                {expandNonBillableOther && (
                                    <View style={{ flexDirection: 'row' }}>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                        <Text style={[s.cell, { width: 100, backgroundColor: '#eef2f6' }]}></Text>
                                    </View>
                                )}
                            </View>
                        )}
                    </View>
                ) : null}
                <Text style={[s.cell, { width: 100 }]}>{ohPercent ? fNum(ohPercent, 1) + '%' : ''}</Text>
                <View style={{ width: 5 }}></View>
                <Text style={[s.cell, { width: 100, fontWeight: 600 }]}>{totals.netProfit ? fNum(totals.netProfit, 1) : ''}</Text>
                <Text style={[s.cell, { width: 100, backgroundColor: avgNetProfitPercent > 40 ? '#bbf7d0' : avgNetProfitPercent < 10 ? '#fecaca' : '', fontWeight: 600 }]}>{avgNetProfitPercent ? parseFloat(avgNetProfitPercent).toFixed(1) + '%' : ''}</Text>
                <View style={{ width: 5 }}></View>
                <Text style={[s.cell, { width: 100 }]}></Text>
                <Text style={[s.cell, { width: 100 }]}></Text>
                <Text style={[s.cell, { width: 100 }]}></Text>
                <Text style={[s.cell, { width: 100 }]}></Text>
                <View style={{ width: 5 }}></View>
                <Text style={[s.cell, { width: 100 }]}>{totals.openPO ? fNum(totals.openPO, 1) : ''}</Text>
            </View>
        );
    };
    // const Footer = () => {
    //     // Calculate totals using the new state variables
    //     const totals = jobList.reduce((acc, job) => {
    //         if (acc && job) {
    //             return {
    //                 invoicedToDate: (acc.invoicedToDate || 0) + (invoicedAmounts[job.BU_ID] || 0),
    //                 ticketsNotYetInvoiced: (acc.ticketsNotYetInvoiced || 0) + (ticketsNotInvoiced[job.BU_ID] || 0),
    //                 currentEarned: (acc.currentEarned || 0) + (currentEarnedAmounts[job.BU_ID] || 0),
    //                 totalBillableCost: (acc.totalBillableCost || 0) + (invoicedAmounts[job.BU_ID] || 0),
    //                 currentGrossProfit: (acc.currentGrossProfit || 0) + (parseFloat(job.currentGrossProfit) || 0),
    //                 totalNonBillableCosts: (acc.totalNonBillableCosts || 0) + (parseFloat(job.totalNonBillableCosts) || 0),
    //                 nonBillableJobProfit: (acc.nonBillableJobProfit || 0) + (parseFloat(job.nonBillableJobProfit) || 0),
    //                 netProfit: (acc.netProfit || 0) + (parseFloat(job.netProfit) || 0),
    //             }
    //         }
    //     }, {});

    //     // Calculate cost type totals
    //     const costTypeTotals = Object.values(actualCosts).reduce((acc, jobCosts) => {
    //         return {
    //             labor: (acc.labor || 0) + (jobCosts.labor || 0),
    //             equipment: (acc.equipment || 0) + (jobCosts.equipment || 0),
    //             materials: (acc.materials || 0) + (jobCosts.materials || 0),
    //             subs: (acc.subs || 0) + (jobCosts.subs || 0),
    //             other: (acc.other || 0) + (jobCosts.other || 0),
    //             thirdParty: (acc.thirdParty || 0) + (jobCosts.thirdParty || 0),
    //             // Add totals for individual cost codes
    //             '51100': (acc['51100'] || 0) + (jobCosts['51100'] || 0),
    //             '51200': (acc['51200'] || 0) + (jobCosts['51200'] || 0),
    //             '51300': (acc['51300'] || 0) + (jobCosts['51300'] || 0),
    //             '51350': (acc['51350'] || 0) + (jobCosts['51350'] || 0),
    //             '51400': (acc['51400'] || 0) + (jobCosts['51400'] || 0),
    //             '51500': (acc['51500'] || 0) + (jobCosts['51500'] || 0),
    //             '51600': (acc['51600'] || 0) + (jobCosts['51600'] || 0),
    //             '51700': (acc['51700'] || 0) + (jobCosts['51700'] || 0),
    //             '51800': (acc['51800'] || 0) + (jobCosts['51800'] || 0),
    //             '52100': (acc['52100'] || 0) + (jobCosts['52100'] || 0),
    //             '52200': (acc['52200'] || 0) + (jobCosts['52200'] || 0),
    //             '52300': (acc['52300'] || 0) + (jobCosts['52300'] || 0),
    //             '52400': (acc['52400'] || 0) + (jobCosts['52400'] || 0),
    //             '53100': (acc['53100'] || 0) + (jobCosts['53100'] || 0),
    //             '53200': (acc['53200'] || 0) + (jobCosts['53200'] || 0),
    //             '53300': (acc['53300'] || 0) + (jobCosts['53300'] || 0),
    //             '53400': (acc['53400'] || 0) + (jobCosts['53400'] || 0),
    //             '54100': (acc['54100'] || 0) + (jobCosts['54100'] || 0),
    //             '54200': (acc['54200'] || 0) + (jobCosts['54200'] || 0),
    //             '54300': (acc['54300'] || 0) + (jobCosts['54300'] || 0),
    //             '55100': (acc['55100'] || 0) + (jobCosts['55100'] || 0),
    //             '55200': (acc['55200'] || 0) + (jobCosts['55200'] || 0),
    //             '55300': (acc['55300'] || 0) + (jobCosts['55300'] || 0),
    //             '55400': (acc['55400'] || 0) + (jobCosts['55400'] || 0),
    //             '55900': (acc['55900'] || 0) + (jobCosts['55900'] || 0),
    //             '56100': (acc['56100'] || 0) + (jobCosts['56100'] || 0),
    //             '56500': (acc['56500'] || 0) + (jobCosts['56500'] || 0),
    //             '57900': (acc['57900'] || 0) + (jobCosts['57900'] || 0),
    //         }
    //     }, {});

    //     // Calculate percentages
    //     const grossProfitPercent = totals.currentEarned ? ((totals.currentGrossProfit / totals.currentEarned) * 100).toFixed(1) + '%' : '0%';
    //     const ohPercent = totals.currentEarned ? ((totals.totalNonBillableCosts / totals.currentEarned) * 100).toFixed(1) + '%' : '0%';
    //     const netProfitPercent = totals.currentEarned ? ((totals.netProfit / totals.currentEarned) * 100).toFixed(1) + '%' : '0%';
    //     const nonBillableJobMargin = totals.currentEarned ? ((totals.nonBillableJobProfit / totals.currentEarned) * 100).toFixed(1) + '%' : '0%';

    //     // Calculate billable totals
    //     const billableTotals = jobList.reduce((acc, job) => {
    //         const jobActualCosts = actualCosts[job.BU_ID] || {};
    //         const totalBillable = (jobActualCosts.labor || 0) +
    //             (jobActualCosts.equipment || 0) +
    //             (jobActualCosts.thirdParty || 0);
    //         const currentEarned = currentEarnedAmounts[job.BU_ID] || 0;
    //         const billableJobProfit = currentEarned - totalBillable;

    //         return {
    //             totalBillable: (acc.totalBillable || 0) + totalBillable,
    //             totalBillableProfit: (acc.totalBillableProfit || 0) + billableJobProfit,
    //             totalEarned: (acc.totalEarned || 0) + currentEarned
    //         };
    //     }, {});

    //     // Calculate total billable margin
    //     const totalBillableMargin = billableTotals.totalEarned ?
    //         ((billableTotals.totalBillableProfit / billableTotals.totalEarned) * 100).toFixed(1) + '%' : '0%';

    //     // Calculate non-billable width for footer
    //     const nonBillableWidth = expandNonBillable ? (
    //         (expandNonBillableLab ? 800 : 0) +
    //         (expandNonBillableEquip ? 400 : 0) +
    //         (expandNonBillableSub ? (
    //             (expandNonBillableMat ? 400 : 0) +
    //             (expandNonBillableSubDetail ? 300 : 0) +
    //             (expandNonBillableOther ? 800 : 0) +
    //             300
    //         ) : 0) +
    //         400
    //     ) : 100;

    //     // Calculate billable width for footer
    //     const billableWidth = expandBilling ? (
    //         (expandLab ? 800 : 0) +
    //         (expandEquip ? 400 : 0) +
    //         (expandSub ? (
    //             (expandMat ? 400 : 0) +
    //             (expandSubDetail ? 300 : 0) +
    //             (expandOther ? 800 : 0) +
    //             300
    //         ) : 0) +
    //         400
    //     ) : 100;

    //     return (
    //         <View style={{ flexDirection: 'row', paddingLeft: 10 }}>
    //             <Text style={[s.cellt, { width: 550, backgroundColor: '#f1f5f9' }]}>Totals</Text>
    //             <View style={{ width: 5 }}></View>
    //             <Text style={[s.cell, { width: 100 }]}>{totals.currentEarned ? fNum(totals.currentEarned, 1) : ''}</Text>
    //             {expandRev ? (
    //                 <View style={{ flexDirection: 'row' }}>
    //                     <Text style={[s.cell, { width: 100 }]}>{totals.invoicedToDate ? fNum(totals.invoicedToDate, 1) : ''}</Text>
    //                     <Text style={[s.cell, { width: 100 }]}>{totals.ticketsNotYetInvoiced ? fNum(totals.ticketsNotYetInvoiced, 1) : ''}</Text>
    //                 </View>
    //             ) : null}
    //             <View style={{ width: 5 }}></View>
    //             {/* Billable section with width calculation */}
    //             <View style={{ width: billableWidth }}>
    //                 {expandBilling ? (
    //                     <View style={{ flexDirection: 'row' }}>
    //                         <Text style={[s.cell, { width: 100 }]}>{totals.totalBillableCost ? fNum(totals.totalBillableCost, 1) : ''}</Text>
    //                         <Text style={[s.cell, { width: 100 }]}>{costTypeTotals.labor ? fNum(costTypeTotals.labor, 1) : ''}</Text>
    //                         {expandLab && (
    //                             <View style={{ flexDirection: 'row' }}>
    //                                 <Text style={[s.cell, { width: 800 }]}></Text>
    //                             </View>
    //                         )}
    //                         <Text style={[s.cell, { width: 100 }]}>{costTypeTotals.equipment ? fNum(costTypeTotals.equipment, 1) : ''}</Text>
    //                         {expandEquip && (
    //                             <View style={{ flexDirection: 'row' }}>
    //                                 <Text style={[s.cell, { width: 400 }]}></Text>
    //                             </View>
    //                         )}
    //                         <Text style={[s.cell, { width: 100 }]}>{costTypeTotals.thirdParty ? fNum(costTypeTotals.thirdParty, 1) : ''}</Text>
    //                         {expandSub && (
    //                             <View style={{ flexDirection: 'row' }}>
    //                                 <Text style={[s.cell, { width: 100 }]}>{costTypeTotals.materials ? fNum(costTypeTotals.materials, 1) : ''}</Text>
    //                                 {expandMat && (
    //                                     <View style={{ flexDirection: 'row' }}>
    //                                         <Text style={[s.cell, { width: 400 }]}></Text>
    //                                     </View>
    //                                 )}
    //                                 <Text style={[s.cell, { width: 100 }]}>{costTypeTotals.subs ? fNum(costTypeTotals.subs, 1) : ''}</Text>
    //                                 {expandSubDetail && (
    //                                     <View style={{ flexDirection: 'row' }}>
    //                                         <Text style={[s.cell, { width: 300 }]}></Text>
    //                                     </View>
    //                                 )}
    //                                 <Text style={[s.cell, { width: 100 }]}>{costTypeTotals.other ? fNum(costTypeTotals.other, 1) : ''}</Text>
    //                                 {expandOther && (
    //                                     <View style={{ flexDirection: 'row' }}>
    //                                         <Text style={[s.cell, { width: 800 }]}></Text>
    //                                     </View>
    //                                 )}
    //                             </View>
    //                         )}
    //                     </View>
    //                 ) : (
    //                     <Text style={[s.cell, { width: 100 }]}>{totals.totalBillableCost ? fNum(totals.totalBillableCost, 1) : ''}</Text>
    //                 )}
    //             </View>
    //             <View style={{ width: 5 }}></View>
    //             <Text style={[s.cell, { width: 100 }]}>{totals.currentGrossProfit ? fNum(totals.currentGrossProfit, 1) : ''}</Text>
    //             <Text style={[s.cell, { width: 100 }]}>{grossProfitPercent}</Text>
    //             <View style={{ width: 5 }}></View>
    //             {/* Non-billable section with width calculation */}
    //             <View style={{ width: nonBillableWidth }}>
    //                 {expandNonBillable ? (
    //                     <View style={{ flexDirection: 'row' }}>
    //                         <Text style={[s.cell, { width: 100 }]}>{totals.totalNonBillableCosts ? fNum(totals.totalNonBillableCosts, 1) : ''}</Text>
    //                         <Text style={[s.cell, { width: 100 }]}>{costTypeTotals.labor ? fNum(costTypeTotals.labor, 1) : ''}</Text>
    //                         {expandNonBillableLab && (
    //                             <View style={{ flexDirection: 'row' }}>
    //                                 <Text style={[s.cell, { width: 800 }]}></Text>
    //                             </View>
    //                         )}
    //                         <Text style={[s.cell, { width: 100 }]}>{costTypeTotals.equipment ? fNum(costTypeTotals.equipment, 1) : ''}</Text>
    //                         {expandNonBillableEquip && (
    //                             <View style={{ flexDirection: 'row' }}>
    //                                 <Text style={[s.cell, { width: 400 }]}></Text>
    //                             </View>
    //                         )}
    //                         <Text style={[s.cell, { width: 100 }]}>{costTypeTotals.thirdParty ? fNum(costTypeTotals.thirdParty, 1) : ''}</Text>
    //                         {expandNonBillableSub && (
    //                             <View style={{ flexDirection: 'row' }}>
    //                                 <Text style={[s.cell, { width: 100 }]}>{costTypeTotals.materials ? fNum(costTypeTotals.materials, 1) : ''}</Text>
    //                                 {expandNonBillableMat && (
    //                                     <View style={{ flexDirection: 'row' }}>
    //                                         <Text style={[s.cell, { width: 400 }]}></Text>
    //                                     </View>
    //                                 )}
    //                                 <Text style={[s.cell, { width: 100 }]}>{costTypeTotals.subs ? fNum(costTypeTotals.subs, 1) : ''}</Text>
    //                                 {expandNonBillableSubDetail && (
    //                                     <View style={{ flexDirection: 'row' }}>
    //                                         <Text style={[s.cell, { width: 300 }]}></Text>
    //                                     </View>
    //                                 )}
    //                                 <Text style={[s.cell, { width: 100 }]}>{costTypeTotals.other ? fNum(costTypeTotals.other, 1) : ''}</Text>
    //                                 {expandNonBillableOther && (
    //                                     <View style={{ flexDirection: 'row' }}>
    //                                         <Text style={[s.cell, { width: 800 }]}></Text>
    //                                     </View>
    //                                 )}
    //                             </View>
    //                         )}
    //                     </View>
    //                 ) : (
    //                     <Text style={[s.cell, { width: 100 }]}>{totals.totalNonBillableCosts ? fNum(totals.totalNonBillableCosts, 1) : ''}</Text>
    //                 )}
    //             </View>
    //             <Text style={[s.cell, { width: 100 }]}>{ohPercent ? fNum(ohPercent, 1) + '%' : ''}</Text>
    //             <View style={{ width: 5 }}></View>
    //             <Text style={[s.cell, { width: 100 }]}>{totals.nonBillableJobProfit ? fNum(totals.nonBillableJobProfit, 1) : ''}</Text>
    //             <Text style={[s.cell, { width: 100 }]}>{nonBillableJobMargin}</Text>
    //             {/* <View style={{ width: 5 }}></View>
    //             <Text style={[s.cell, { width: 100 }]}>{totals.netProfit ? fNum(totals.netProfit, 1) : ''}</Text>
    //             <Text style={[s.cell, { width: 100 }]}>{netProfitPercent}</Text>
    //             <View style={{ width: 5 }}></View>
    //             <Text style={[s.cell, { width: 100 }]}>{billableTotals.totalBillableProfit ? fNum(billableTotals.totalBillableProfit, 1) : ''}</Text>
    //             <Text style={[s.cell, { width: 100 }]}>{totalBillableMargin}</Text> */}
    //         </View>
    //     );
    // }

    return (
        <View>
            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                .spinner-icon {
                    animation: spin 1s linear infinite;
                }
            `}</style>
            <View style={{ margin: 16, backgroundColor: 'white', padding: 16, marginBottom: 150, borderRadius: 8, border: '1px solid #e2e8f0', boxShadow: '0 1px 2px 0 rgba(15, 23, 42, 0.04)', overflowX: 'auto' }}>
                <Header />
                {jobList.map((job, i) => (
                    <View key={i} style={{ marginBottom: 8 }}>
                        {rollingNineVersions.map((version, j) => (
                            <Row key={j} job={job} version={version} first={j === rollingNineVersions.length - 1} />
                        ))}
                    </View>
                ))}
                <Footer />
            </View>
        </View>
    );
});

export default TimeMaterialsReportRolling9;



